import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const PlanningAndResearch = () => {
    return <SharedDocumentsComponent permissionId="17" path="Planejamento e Pesquisa" />
}